import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { AlertCircleIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'

export const AttentionBadge: React.FC = () => {
  return (
    <Box sx={{
      display: 'flex',
      gap: 1,
      backgroundColor: 'badgeBorderColor.info.main',
      borderRadius: 1,
      paddingX: 3,
      paddingY: 2,
      alignItems: 'center'
    }}>
      <AlertCircleIcon htmlColor={mutualTheme.palette.badgeBackgroundColor.info.light} />
      <Typography variant='airbnbBody1'>
        <Typography variant='airbnbBody1' sx={{ fontWeight: 'bold' }}>Atenção: </Typography>
        esta é uma pré-proposta. A aprovação do crédito e os valores finais estão sujeitos à análise de documentação.
      </Typography>
    </Box>
  )
}
